import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials sends the httpOnly auth cookie on every admin request.
// Since the cookie is httpOnly, it cannot be read or set from JS — only
// the browser can attach it.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const path = typeof window !== "undefined" ? window.location.pathname : "";
            if (path.startsWith("/admin") && path !== "/adminoth") {
                window.location.href = "/adminoth";
            }
        }
        return Promise.reject(err);
    }
);

export const fetchContent = async () => (await api.get("/content")).data;
export const fetchAdminContent = async () => (await api.get("/admin/content")).data;
export const saveContent = async (data) => (await api.put("/content", data)).data;
export const resetContent = async () => (await api.post("/content/reset")).data;
export const login = async (email, password) => (await api.post("/auth/login", { email, password })).data;
export const logout = async () => (await api.post("/auth/logout")).data;
export const submitLead = async (lead) => (await api.post("/leads", lead)).data;
